import { createAction, props } from '@ngrx/store';
import { Log } from '../../../types/interfaces/log';

export const getLogsDateRanges = createAction('[Logs] Get Logs Date Ranges');

export const getLogsDateRangesSuccess = createAction(
  '[Logs] Get Logs Date Ranges Success',
  props<{ startDate: string; endDate: string }>()
);

export const getLogs = createAction(
  '[Logs] Get Logs',
  props<{
    startDate?: string;
    endDate?: string;
    level?: string;
    searchTerm?: string;
  }>()
);
export const getLogsSuccess = createAction(
  '[Logs] Get Logs Success',
  props<{ logs: Log[] }>()
);

export const clearLogs = createAction('[Logs] Clear Logs');

export const LogsActions = {
  getLogs,
  getLogsSuccess,
  clearLogs,
  getLogsDateRanges,
  getLogsDateRangesSuccess,
};
